import { MIN_VOICE_QUANTITY } from "@/lib/voice-order";
import { Minus, Plus } from "lucide-react";
import { memo } from "react";

interface VoiceQuantityStepperProps {
  quantity: number;
  disabled?: boolean;
  onChange: (quantity: number) => void;
  /** For the accessible labels, e.g. "Increase quantity of Foils". */
  label: string;
}

/**
 * Compact `-`/`+` quantity stepper for the voice review, matching the reorder
 * review dialog's inline stepper. Clamps at {@link MIN_VOICE_QUANTITY} - a line
 * is removed by un-including it, never by stepping to zero.
 */
export const VoiceQuantityStepper = memo(function VoiceQuantityStepper({
  quantity,
  disabled = false,
  onChange,
  label
}: VoiceQuantityStepperProps) {
  return (
    <div className="border-border inline-flex w-fit items-center rounded-md border">
      <button
        type="button"
        className="flex h-7 w-7 items-center justify-center text-gray-600 hover:bg-gray-100 disabled:opacity-40 dark:text-gray-300 dark:hover:bg-neutral-800"
        onClick={() => onChange(quantity - 1)}
        disabled={disabled || quantity <= MIN_VOICE_QUANTITY}
        aria-label={`Decrease quantity of ${label}`}
      >
        <Minus className="h-3 w-3" aria-hidden="true" />
      </button>
      <span className="w-7 text-center text-xs tabular-nums">{quantity}</span>
      <button
        type="button"
        className="flex h-7 w-7 items-center justify-center text-gray-600 hover:bg-gray-100 disabled:opacity-40 dark:text-gray-300 dark:hover:bg-neutral-800"
        onClick={() => onChange(quantity + 1)}
        disabled={disabled}
        aria-label={`Increase quantity of ${label}`}
      >
        <Plus className="h-3 w-3" aria-hidden="true" />
      </button>
    </div>
  );
});
